import { Component, OnInit, ViewChild } from '@angular/core';
import { MapControls } from '../utilities/MapControls/MapConrols';
import { Trip } from '../DataStructures/Trip/Trip';
import { LocationData } from '../shared/location-picker/location-picker.component';
import { Destination } from '../DataStructures/Destination/Destination';
import { QuickDialog } from '../utilities/Dialog/QuickDialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TimePickerComponent } from '../shared/time-picker/time-picker.component';
import { Router } from '@angular/router';
import { MatDatepicker } from '@angular/material';
declare var google: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  @ViewChild('timepicker') timepicker:TimePickerComponent;
  @ViewChild('picker') picker:any;
  today;
  fromInput;
  fromAutoComplete;
  toInput;
  toAutoComplete;
  requestForm: FormGroup;

  constructor(private mapControls:MapControls,private formBuilder: FormBuilder,private router:Router) {
    this.today = new Date();
    this.requestForm = this.formBuilder.group({
      from: [null, [Validators.required]],
      to: [null, [Validators.required]],
      fromlat: [null, [Validators.required]],
      fromlng: [null, [Validators.required]],
      tolat: [null, Validators.required],
      tolng: [null, Validators.required],
      date: [null, [Validators.required]],
      time: [null, [Validators.required]],
      passengers:[1,[Validators.required]]
    })
  }

  ngOnInit() {
    this.initAutoComplete();
  }

  focusInput(input,container = null){
    input.focus();
    if(container){
      container.className = `request-input-container focus-border`;
    }
  }

  focusDate(container,pickupdate){
    pickupdate.focus();
    this.picker.open();
    setTimeout(() =>{
      if(container){
        container.className = `request-input-container focus-border`;
      }
    },0);
  }

  focusPicker(container){
    this.timepicker.focus();
    if(container){
      container.className = `request-input-container focus-border`;
    }
  }

  plus(){
    var p = this.requestForm.getRawValue().passengers;
    if(p < 30){
      this.requestForm.patchValue({
        passengers:(p += 1)
      })
    }
  }

  minus(){
    var p = this.requestForm.getRawValue().passengers;
    if(p > 1){
      this.requestForm.patchValue({
        passengers:(p -= 1)
      })
    }
  }

  request(){
    this.requestForm.patchValue({
      time:this.timepicker.getTime()
    })
    if(this.requestForm.valid){
      this.router.navigate(['/book-ride'], { queryParams:this.requestForm.getRawValue()})
    }
  }

  blurInput(container){
    if(container){
      container.className = `request-input-container`;
    }
  }

  initAutoComplete() {
    this.fromInput = document.getElementById('from');
    this.fromAutoComplete = new google.maps.places.Autocomplete(this.fromInput, this.getOptions());
    this.regFromAutoCompleteListener();

    this.toInput = document.getElementById('to');
    this.toAutoComplete = new google.maps.places.Autocomplete(this.toInput, this.getOptions());
    this.regToAutoCompleteListener();

  }

  regFromAutoCompleteListener() {

    this.mapControls.registerAutcompleteListener('place_changed', this.fromAutoComplete).then(place => {
      var f: any = document.getElementById('from');
      var loc = new LocationData(f.value, place.geometry.location.lat(), place.geometry.location.lng());
      this.requestForm.patchValue({
        from:loc.address,
        fromlat:loc.lat,
        fromlng:loc.lng
      })
      this.regFromAutoCompleteListener();
    }).catch(e => {
      this.regFromAutoCompleteListener();
    })
  }

  regToAutoCompleteListener() {

    this.mapControls.registerAutcompleteListener('place_changed', this.toAutoComplete).then(place => {
      var t: any = document.getElementById('to');
      var loc = new LocationData(t.value, place.geometry.location.lat(), place.geometry.location.lng());
      this.requestForm.patchValue({
        to:loc.address,
        tolat:loc.lat,
        tolng:loc.lng
      })
      this.regToAutoCompleteListener();
    }).catch(e => {
      this.regToAutoCompleteListener();
    })
  }


  

  getOptions() {
    var defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(17.546889258900055, -78.54058735825066),
      new google.maps.LatLng(18.591323377300697, -76.02471821762566)
    )
    return {
      bounds: defaultBounds
    };
  }


}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts